
import barba from '@barba/core';

export default class{

	constructor(){
        barba.hooks.afterOnce(() => {
            this.isResize = false
            this.init()
            window.addEventListener('resize',this.resize.bind(this))
        });
	}
    init (){
        document.documentElement.style.setProperty('--viewport-height',`${document.documentElement.clientHeight }px`)
    }
    resize(){
        if(this.isResize){
            return false
        }
        this.isResize = true
        this.init()
        setTimeout(() => {
            this.isResize = false
        }, 100)
    }
}